export const isVulnSearchQuery = (id: string) =>
  /^(CVE-|DEBIAN-CVE-|UBUNTU-CVE-)/i.test(id);

export const getCveOrgHref = (searchQuery: string) =>
  `https://www.cve.org/CVERecord?id=${searchQuery.toUpperCase()}`;
